import React from "react";
import styled from "styled-components";
import upArrow from "assets/icons/arrow-up.svg";

import FooterReportNavigator from "./FooterReportNavigator";

let contentRightSide;

function reportWindowSize() {
  contentRightSide = document
    ?.getElementById("reportContent")
    ?.getBoundingClientRect();

  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );

  const menuWidth = (document.getElementById("ReportMenu")?.clientWidth || document.getElementById("CustomReportMenu")?.clientWidth) ?? 0;
  const contentWidth = document.getElementById("reportContent")?.clientWidth ?? 0;

  if (vw > 1000 && contentRightSide !== undefined) {
    document
      .getElementById("reportFooter")
      // ?.setAttribute("style", `left: ${contentRightSide.width}px`);
      ?.setAttribute("style", `left: ${menuWidth + contentWidth - 30}px`);
  } else {
    // document.getElementById("reportFooter")?.removeAttribute("style");
    document
      .getElementById("reportFooter")
      ?.setAttribute("style", `left: ${0}px`);
  }
}

window.addEventListener("resize", reportWindowSize);
window.addEventListener("scroll", reportWindowSize);

// searching: the report page shows the count during a search, with 0 of 0 when
// nothing is highlighted; custom reports don't pass it
const ReportFooter: React.FC<{ scrollPositions; searching?: boolean }> = ({
  scrollPositions,
  searching = false,
}) => {
  reportWindowSize();

  const reportContent = document.getElementById("reportContent");
  if (reportContent) {
    const resizeObserver = new ResizeObserver(() => {
      reportWindowSize();
    });
    resizeObserver.observe(reportContent);
  }

  return (
    <Container id="reportFooter">
      <ReportNavigatorDiv>
        {(searching || scrollPositions.length > 0) && <FooterReportNavigator />}
      </ReportNavigatorDiv>
      <BTTLink
        onClick={() => {
          (document.getElementById("ReportHeader") || document.getElementById("CustomReportHeader"))?.parentElement?.
            scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
        }}
        title="Back to top"
      >
        <UpArrow src={upArrow} alt="up arrow" />
      </BTTLink>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 8rem;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  pointer-events: none;
`;

const BTTLink = styled.button`
  color: ${(props) => props.theme.colors.idataDarkBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 2rem;
  background-color: ${(props) => props.theme.colors.grey};
  padding: 0.5rem;
  pointer-events: auto;
  opacity: 0.9;

  &:hover {
    opacity: 0.75;
  }

  @media screen and (max-width: 1305px) {
    margin: 0;
    margin-right: 2rem;
  }
`;

const UpArrow = styled.img`
  /* margin-bottom: -1rem; */
`;

const ReportNavigatorDiv = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: block;
  }
`;
export default ReportFooter;
